<lib-header-layout>
  <lib-title [applicationName]="applicationName" [workCenterName]="'APP.LIVE_APPLICATION_SUBTITLE' | translate"
    [packagramLogoEnabled]='packagramLogoEnabled'></lib-title>
  <lib-info-log></lib-info-log>
  <lib-version-number [version]="version"></lib-version-number>
  <lib-user></lib-user>
  <lib-environment *ngIf="false" [message]="'HEADER.NON_PRODUCTION' | translate"></lib-environment>
</lib-header-layout>
